export default __webpack_public_path__ + "static/media/immoscore-light.7a2e696e.svg";